import http from '../httpService';
import {getLanguage, t} from 'react-switch-lang';

const nameVal = getLanguage() === "eng" ? "nameEn" : "name";
export function getAllCourtCategoryRisksTable() {
  return http.get(`/court-category-risks?sort=${nameVal}`);
}
export async function getAllCourtCategoryRisks(page = 0, result = []) {
  const { data } = await http.get(
    `/court-category-risks?page=${page}&size=20&sort=${nameVal}`
  );

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllCourtCategoryRisks(page + 1, result);
}

export function updateCourtCategoryRisk(payload) {
  return http.put('/court-category-risks', payload);
}

export function createCourtCategoryRisk(payload) {
  return http.post('/court-category-risks', payload);
}

export function deleteCourtCategoryRisk(id) {
  return http.delete(`/court-category-risks/${id}`);
}
